import { render, staticRenderFns } from "./PlantSizesAccordion.vue?vue&type=template&id=44d50a46&scoped=true&"
import script from "./PlantSizesAccordion.vue?vue&type=script&lang=ts&"
export * from "./PlantSizesAccordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d50a46",
  null
  
)

export default component.exports